/**
 * Format a number with thousands separators (e.g. 12345 → "12,345").
 */
export function formatNumber(value: number | undefined | null): string {
  if (value == null) return '0';
  return value.toLocaleString('en');
}

interface CurrencyFormatOptions {
  locale?: string;
  currency: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatCurrency(
  amount: number | undefined | null,
  options: CurrencyFormatOptions,
): string {
  if (amount == null) return 'N/A';
  return new Intl.NumberFormat(options.locale || 'en', {
    style: 'currency',
    currency: options.currency,
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  }).format(amount);
}

/**
 * Format currency with accounting-style negatives: $ (4,242.42)
 * Positive: $4,242.42 | Negative: $ (4,242.42) | Null: N/A
 */
export function formatAccountingCurrency(
  amount: number | undefined | null,
  decimals = 2,
): string {
  if (amount == null) return 'N/A';
  const abs = Math.abs(amount);
  const num = new Intl.NumberFormat('en', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(abs);
  if (amount < 0) return `$ (${num})`;
  return `$${num}`;
}
